module.exports = __webpack_public_path__ + "img/manage-profile.6937d55b.svg";